module.exports = {"school-name":"Columbia College Chicago","logo":"/sites/columbia-college/logo.png","logout-color":"#00874f","logout-font-color":"#fff","header-color":"#000","header-border-color":"#00874f","footer-color":"#000","footer-info":"© 2020 Columbia College Chicago | The Write Class™ | © 2020 Boise State University","help-button-color":"#00874f","help-button-font-color":"#FFFFFF"}


//////////////////
// WEBPACK FOOTER
// ./sites/columbia-college/site-config.json
// module id = 116
// module chunks = 12